import PropTypes from 'prop-types';
import classNames from 'classnames';

import './style.scss';

const Input = ({ onChange, value, type, className, ...props }) => {
	const classes = classNames(className, 'eform-gtb-input');
	return (
		<input
			type={type}
			value={value}
			onChange={onChange}
			className={classes}
			{...props}
		/>
	);
};

Input.propTypes = {
	onChange: PropTypes.func.isRequired,
	value: PropTypes.string.isRequired,
	type: PropTypes.oneOf([
		'text',
		'number',
		'tel',
		'url',
		'email',
		'password',
		'date',
		'datetime-local',
		'search',
	]),
	className: PropTypes.string,
};
Input.defaultProps = {
	type: 'text',
	className: null,
};

export default Input;
